var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "romania",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M156.435.933A15.055,15.055,0,0,0,146,.933L144.7,15,146,29.067a15.054,15.054,0,0,0,10.435,0L157.739,15Z",
    transform: "translate(-136.217 0)",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M354.826,29.99a15.005,15.005,0,0,0-9.783-14.067V44.057A15.006,15.006,0,0,0,354.826,29.99Z",
    transform: "translate(-324.825 -14.99)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M0,29.991A15.006,15.006,0,0,0,9.783,44.058V15.924A15.005,15.005,0,0,0,0,29.991Z",
    transform: "translate(0 -14.991)",
    fill: "#0052b4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRo);
export default __webpack_public_path__ + "static/media/RO.a7e35a5f2bf2f9d6dfb6aca178d99691.svg";
export { ForwardRef as ReactComponent };